import React from "react"
import View from "components/home/HomeAdmin.view"

function HomeAdmin() {
	return <View/>
}

export default HomeAdmin